import { useCallback } from "react";
import { Button } from "@mui/material";
import { Download, FileDownloadOff } from "@mui/icons-material";
import { DossierExport } from "types/DossierExport";
import { DossierExportStatus } from "types/DossierExportStatus";

export interface DossierExportDownloadButtonProps {
    dossierExport: DossierExport;
}

export function DossierExportDownloadButton(
    props: DossierExportDownloadButtonProps,
) {
    const downloadBatchFile = useCallback(async () => {
        const hiddenElement = document.createElement("a");
        hiddenElement.href = props.dossierExport.downloadUrl ?? "";
        hiddenElement.target = "_blank";
        hiddenElement.click();
    }, []);

    return (
        <>
            <Button
                startIcon={
                    props.dossierExport.status ===
                    DossierExportStatus.Completed ? (
                        <Download />
                    ) : (
                        <FileDownloadOff />
                    )
                }
                disabled={
                    props.dossierExport.status !== DossierExportStatus.Completed
                }
                onClick={() => {
                    downloadBatchFile();
                }}
            >
                Download
            </Button>
        </>
    );
}
